export interface ForYouItem {
  title: string
  body: string
  icon: 'leaf' | 'home' | 'gift' | 'store'
}

export const forYouItems: ForYouItem[] = [
  {
    icon: 'leaf',
    title: 'Querés un hobby creativo y relajante',
    body: 'Un rato de manos ocupadas, lejos de la pantalla, con algo lindo al final.',
  },
  {
    icon: 'home',
    title: 'Te gusta la decoración natural y delicada',
    body: 'Piezas botánicas que combinan con tu casa y duran años.',
  },
  {
    icon: 'gift',
    title: 'Querés crear regalos únicos con flores reales',
    body: 'Flores de tu jardín convertidas en un regalo que nadie más tiene.',
  },
  {
    icon: 'store',
    title: 'Te gustaría hacer piezas para vender',
    body: 'Materiales de bajo costo, piezas de alto valor percibido.',
  },
]
